import { computed, Signal, WritableSignal } from '@angular/core';
import { GridViews, WcgMenuOption } from '@wcg/frontend-framework';
import {
  DispatchGridViews,
  GridType,
  GridView,
  GridViewDialogData,
  GridViewFacade,
} from '../types';

export abstract class GridViewAbstract implements GridViewFacade {
  abstract $gridType: Signal<GridType>;
  abstract $gridTotal: Signal<number>;
  abstract $selectedView: Signal<WcgMenuOption>;
  abstract $gridViews: WritableSignal<GridViews[]>;
  abstract $currentGridView: WritableSignal<GridViews>;
  abstract $isTableColumnChanged: Signal<boolean>;

  /** Defaults to $isTableColumnChanged; subclasses may override with richer filter comparison. */
  $hasFilterChanges: Signal<boolean> = computed(() =>
    this.$isTableColumnChanged(),
  );

  abstract setSelectedView(
    view: WcgMenuOption,
    resetSelectView?: boolean,
  ): void;
  abstract saveGridView(viewConfig: GridView): void;
  abstract updateGridView(viewConfig: GridView): void;
  abstract bulkUpdateGridViews(viewConfig: DispatchGridViews): void;
  abstract openGridDialog(viewConfig: GridViewDialogData): void;
  abstract revertGridSettings(): void;
}
